import React from "react";
import styled, { css } from "styled-components";
import styleguide from "../../theme";
import { ResponsiveValue } from "../../types/style-types";

type Direction = "row" | "column";

type StackProps = {
  className?: string;
  children: React.ReactNode;
  spacing: ResponsiveValue<number>;
  direction?: ResponsiveValue<Direction>;
  alignItems?: ResponsiveValue<
    "stretch" | "flex-start" | "center" | "flex-end"
  >;
  justifyContent?: ResponsiveValue<
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly"
  >;
};
type StyledProps = Required<
  Pick<StackProps, "direction" | "alignItems" | "spacing" | "justifyContent">
>;

const Container = styled.div<StyledProps>`
  display: flex;
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};

  ${({ direction }) => {
    if (typeof direction === "string") {
      return `flex-direction: ${direction};`;
    }

    return css`
      flex-direction: ${direction.mobile};

      @media (min-width: ${styleguide.breakpoints.tablet}) {
        flex-direction: ${direction.tablet};
      }

      @media (min-width: ${styleguide.breakpoints.desktop}) {
        flex-direction: ${direction.desktop};
      }
    `;
  }}

  ${({ spacing }) => {
    if (typeof spacing === "number") {
      return `gap: ${spacing}px;`;
    }

    return css`
      gap: ${spacing.mobile}px;

      @media (min-width: ${styleguide.breakpoints.tablet}) {
        gap: ${spacing.tablet}px;
      }

      @media (min-width: ${styleguide.breakpoints.desktop}) {
        gap: ${spacing.desktop}px;
      }
    `;
  }}
`;

export function Stack({
  className,
  children,
  spacing,
  direction = "column",
  alignItems = "stretch",
  justifyContent = "flex-start"
}: StackProps) {
  return (
    <Container
      className={className}
      direction={direction}
      spacing={spacing}
      alignItems={alignItems}
      justifyContent={justifyContent}
    >
      {children}
    </Container>
  );
}

export default Stack;
